import type { Kurs } from "./general";

export const KursyPopList: Array<Kurs> = [
	{
		slug: "pop_vat_podst",
		title: "Podatki od Podstaw VAT",
		description:
			"Idealny wybór dla tych, którzy potrzebują solidnych fundamentów związanych z opodatkowaniem, definicjami oraz podstawowymi mechanizmami transakcji.",
		level: "podstawa",
		category: "vat",
	},
	{
		slug: "pop_vat_rozsz",
		title: "Podatki od Podstaw VAT",
		description:
			"Kompleksowy kurs, który pogłębia i rozszerza wiedzę z zakresu podatku VAT, czyniąc uczestników ekspertami w tej dziedzinie.",
		level: "rozszerzenie",
		category: "vat",
	},
	{
		slug: "pop_pit_podst",
		title: "Podatki od Podstaw PIT",
		description:
			"To praktyczny kurs, który w zrozumiały sposób wprowadza w świat podatku dochodowego od osób fizycznych.",
		level: "podstawa",
		category: "pit",
	},
	{
		slug: "pop_pit_rozsz",
		title: "Podatki od Podstaw PIT",
		description:
			"Zaawansowany kurs, który pozwoli Ci gruntownie pogłębić znajomość podatku dochodowego od osób fizycznych.",
		level: "rozszerzenie",
		category: "pit",
	},
	{
		slug: "pop_cit_podst",
		title: "Podatki od Podstaw CIT",
		description:
			"Od podstawowych informacji, przez rok podatkowy, zaliczki, stawki podatku, aż po szczegóły dotyczące przychodów podatkowych.",
		level: "podstawa",
		category: "cit",
	},
	{
		slug: "pop_cit_rozsz",
		title: "Podatki od Podstaw CIT",
		description:
			"Kurs został stworzony, aby znacząco poszerzyć i uzupełnić Twoją wiedzę z zakresu podatku CIT, wznosząc Twoje kompetencje na wyższy poziom.",
		level: "rozszerzenie",
		category: "cit",
	},
	{
		slug: "pop_cit_eston_podst",
		title: "Podatki od Podstaw CIT Estoński",
		description:
			"Nasz kurs przybliża nie tylko teoretyczne aspekty CIT Estońskiego, ale i kluczowe praktyki.",
		level: "podstawa",
		category: "cit-eston",
	},
	{
		slug: "pop_cit_eston_rozsz",
		title: "Podatki od Podstaw CIT Estoński",
		description:
			"Niepowtarzalna dawka wiedzy dla tych, którzy znają podstawy i chcą pogłębić znajomość zaawansowanych aspektów tego opodatkowania.",
		level: "rozszerzenie",
		category: "cit-eston",
	},
	{
		slug: "pop_podst_prawa_podatk_podst",
		title: "Podatki od Podstaw Podstawy prawa podatkowego",
		description:
			"Praktyczny fundament w zrozumieniu prawa podatkowego, baza wiedzy dla każdego, kto chce zrozumieć podatki.",
		level: "podstawa",
		category: "podstawy-prawa-podatkowego",
	},
	{
		slug: "pop_kontrole_postep_podstw",
		title: "Podatki od Podstaw Kontrole i postępowania",
		description:
			"Idealny kurs dla osób zawodowo związanych z finansami i podatkami, które chcą wzbogacić swoje kompetencje w zakresie przepisów i procedur związanych z kontrolami.",
		level: "podstawa",
		category: "kontrole-postep",
	},
	{
		slug: "pop_kontrole_postep_rozsz",
		title: "Podatki od Podstaw Kontrole i postępowania",
		description:
			"Dla osób pragnących podnieść swoje kompetencje i stać się ekspertami w obszarze kontroli i postępowań podatkowych.",
		level: "rozszerzenie",	
		category: "kontrole-postep",
	},
];